export default __webpack_public_path__ + "static/media/Beco_430x687.f8dc903f.webp";